import React, { useMemo, useRef, useState, } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const HiinformationForm = ({ navigation, route }): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params


  const [totalWithholdingAllowance, setTotalWithholdingAllowance] = useState('');

  const options2 = [
    { key: 1, value: 'You or your spouse qualifies' },
    { key: 2, value: 'If both you and your spouse qualify' },
    { key: 3, value: 'No age withholding' }
  ];
  const options3 = [
    { key: 1, value: 'Yes' },
    { key: 2, value: 'No' },


  ]
  const options5 = [
    { key: 1, value: 'Yes' },
    { key: 2, value: 'No' }

  ]

  const options1 = [
    { key: 1, value: 'Single' },
    { key: 2, value: 'Married' },
    { key: 3, value: 'Married, but withhold at higher Single rate' },
    { key: 4, value: 'Certified Disabled Person (not subject to withholding)' },
    { key: 5, value: 'Nonresident Military Spouse (not subject to withholding)' }
  ]
  const options4 = [
    { key: 1, value: 'Married filing jointly or surviving spouse', amount: 4400 },
    { key: 2, value: 'Head of household ', amount: 3212 },
    { key: 3, value: 'Single', amount: 2200 },
    { key: 4, value: 'Married filing separately', amount: 2200 }
  ]



  const intialValues = {
    filingStatus: null,
    totalnoofallowances: '',
    youasadependent: '',
    martialwithjobstatus: '',
    spouseclaimingstatus: '',
    ageadditionalwithholdingallowances: '',
    noofdependents: '',
    claimashousehold: '',
    totaltaxcredits: '',
    itemizeorclaimadjustmentstoincome: '',
    totalwithholdingallowances: '',
    currentyearitemizeddeductions: '',
    martialdeductions: '',
    resultofmartialdeductionsandcurrentyeardeductions: '',
    estimateadjustmentstoincome: '',
    additionofresultandcurrentyearadjustments: '',
    estimatenonwageincome: '',
    Resultofnonwageincome: '',
    divideresultofnonwageby1144: '',
    additionalamount: '',
    Toclaimadjustincome: '',
    Taxfiling: '',
    additonalamountstatus: '',
    additonalamount: '',
    filingamount: ""
  }
  const alschema = yup.object({
    filingStatus: yup.string().required('Martial Status is a required field'),
    youasadependent: yup.string().required('Dependent status is a required field'),
    martialwithjobstatus: yup.string().required('Martialwithjobstatus status is a required field'),
    spouseclaimingstatus: yup.string().when("filingStatus", (filingStatus: any, schema) => {
      if (filingStatus == 2) {
        return schema.required('Spouse claiming status status is a required field')
      }
      return schema.nullable()
    }),
    ageadditionalwithholdingallowances: yup.string().required('Age Allowances status is a required field').nullable(),
    noofdependents: yup.string().required('Enter number of dependents is a required field'),
    claimashousehold: yup.string().required('Household head status is a required field'),
    totaltaxcredits: yup.string().required('Estimate tax is a required field'),
    Toclaimadjustincome: yup.string().required('Planning to itemize or claim adjustments to income is a required field'),
    currentyearitemizeddeductions: yup.string().when("Toclaimadjustincome", (Toclaimadjustincome: any, schema) => {
      if (Toclaimadjustincome == 1) {
        return schema.required('Enter Itemized deduction is a required field')
      }
      return schema.nullable()
    }),
    estimateadjustmentstoincome: yup.string().when("Toclaimadjustincome", (Toclaimadjustincome: any, schema) => {
      if (Toclaimadjustincome == 1) {
        return schema.required('Enter Current years adjustments is a required field')
      }
      return schema.nullable()
    }),
    estimatenonwageincome: yup.string().when("Toclaimadjustincome", (Toclaimadjustincome: any, schema) => {
      if (Toclaimadjustincome == 1) {
        return schema.required('Enter Current years Interest or dividends is a required field')
      }
      return schema.nullable()
    }),
    additonalamountstatus: yup.string().required('Enter Additional amount status is a required field'),
    additonalamount: yup.string().when("additonalamountstatus", (additonalamountstatus: any, schema) => {
      if (additonalamountstatus == 1) {
        return schema.required('Enter additional amount is a required field')
      }
      return schema.nullable()
    }),

    Taxfiling: yup.string().when("Toclaimadjustincome", (Toclaimadjustincome: any, schema) => {
      if (Toclaimadjustincome == 1) {
        return schema.required('Tax Filing Status is a required field')
      }
      return schema.nullable()
    }),



  })



  const { loading, posthionline, getmodetails } = useFormsStore()
  const intializeStore = useInitializeStore()
  const personalstore = usePersonalStore()

  let filingdescription = ""
  let amount;
  let resultofmartialdeductionsandcurrentyeardeduction = null
  let additionofresultandcurrentyearadjustment = null
  let Resultofnonwageincomes = null
  let divideresultofnonwage1144 = null
  let totalwithholdingallowance = null

  const safeNumber = (value) => {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  };

  const computevalues = (values) => {
    resultofmartialdeductionsandcurrentyeardeduction = Math.max(
      safeNumber(values.currentyearitemizeddeductions) - safeNumber(values?.filingamount),
      0
    );
    additionofresultandcurrentyearadjustment = resultofmartialdeductionsandcurrentyeardeduction + safeNumber(values.estimateadjustmentstoincome)
    Resultofnonwageincomes = Math.max(
      additionofresultandcurrentyearadjustment - safeNumber(values.estimatenonwageincome),
      0
    );
    divideresultofnonwage1144 = Math.floor(Resultofnonwageincomes / 1144)
    totalwithholdingallowance = safeNumber(divideresultofnonwage1144) + safeNumber(values.youasadependent) + safeNumber(values.noofdependents) + safeNumber(values.claimashousehold) + safeNumber(values.totaltaxcredits) + safeNumber(values.martialwithjobstatus) + safeNumber(values.spouseclaimingstatus) + safeNumber(values.ageadditionalwithholdingallowances)

    setTotalWithholdingAllowance(totalwithholdingallowance?.toString())
  }




  const handlesubmit = async (values) => {
    const data = {
      essUserKey: intializeStore.initializeData?.userkey,
      entityId: personalstore.personalData?.entityId,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      martialstatus: Number(values.filingStatus),
      totalnoofallowances: totalwithholdingallowance,
      additionalamount: Number(values.additonalamount),
      youasadependent: Number(values.youasadependent) === 2 ? null : Number(values.youasadependent),
      martialwithjobstatus: Number(values.martialwithjobstatus) === 2 ? null : Number(values.martialwithjobstatus),
      spouseclaimingstatus: Number(values.spouseclaimingstatus) === 2 ? null : Number(values.spouseclaimingstatus),
      ageadditionalwithholdingallowances: values.ageadditionalwithholdingallowances ? Number(values.ageadditionalwithholdingallowances) : null,
      noofdependents: Number(values.noofdependents),
      claimashousehold: Number(values.claimashousehold) === 2 ? null : Number(values.claimashousehold),
      totaltaxcredits: Number(values.totaltaxcredits) === 2 ? null : Number(values.totaltaxcredits),
      itemizeorclaimadjustmentstoincome: divideresultofnonwage1144,
      totalwithholdingallowances: totalwithholdingallowance,
      currentyearitemizeddeductions: Number(values.currentyearitemizeddeductions),
      martialdeductions: Number(values?.filingamount),
      resultofmartialdeductionsandcurrentyeardeductions: resultofmartialdeductionsandcurrentyeardeduction,
      estimateadjustmentstoincome: Number(values.estimateadjustmentstoincome),
      additionofresultandcurrentyearadjustments: additionofresultandcurrentyearadjustment,
      estimatenonwageincome: Number(values.estimatenonwageincome),
      resultofnonwageincome: Resultofnonwageincomes,
      divideresultofnonwageby1144: divideresultofnonwage1144,
      completeOnline: mode == "online" ? true : false
    }
    const response: any = await posthionline(data)
    if (response?.success === true) {
      if (mode === 'online') {
        navigation.navigate('Hionline', {
          userId,
          mode,
          essUserOnBoardingKey,
          essUserOnBoardingFormKey,
          values,
          filingdescription,
          totalwithholdingallowance,
          resultofmartialdeductionsandcurrentyeardeduction,
          additionofresultandcurrentyearadjustment,
          Resultofnonwageincomes,
          divideresultofnonwage1144
        })
      } else {
        await Toast.show({
          type: 'success',
          position: 'bottom',
          text1: response?.message,
          visibilityTime: 3000,
          autoHide: true,
          topOffset: 60,
          onHide: () => {
            navigation.replace('OnboardingForms')
          }
        })
      }
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }


  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'HI Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          validate={(values) => {

            computevalues(values)


            return {};
          }}
          onSubmit={async (values, actions) => {
            computevalues(values)
            await handlesubmit(values)
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%', overflow: 'hidden' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Marital Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Marital Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.filingStatus
                      )}
                      onSelect={(option: any) => {
                        if (option != 2) {
                          props.setFieldValue('spouseclaimingstatus', '')
                        }
                        const filtered = options1.find((item) => (item.key == option))
                        filingdescription = filtered.value
                        props.setFieldValue('filingStatus', option)

                      }}
                      textColor="primary"
                    />
                    {props.touched.filingStatus &&
                      props.errors.filingStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingStatus as string}
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Are you  claiming withholding for yourself if no one else can claim you as a dependent *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Are you  claiming withholding for yourself if no one else can claim you as a dependent"
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.youasadependent
                      )}
                      onSelect={(option: any) => {
                        if (option == 1) {
                          props.setFieldValue('youasadependent', option)
                        }
                        else {
                          props.setFieldValue('youasadependent', 0)
                        }


                      }}
                      textColor="primary"
                    />
                    {props.touched.youasadependent &&
                      props.errors.youasadependent && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.youasadependent as string}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Are you single and have only one job OR Are you married, have only one job, and your spouse does not work*'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Are you single and have only one job OR Are you married, have only one job, and your spouse does not work"
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.martialwithjobstatus
                      )}
                      onSelect={(option: any) => {
                        if (option == 1) {
                          props.setFieldValue('martialwithjobstatus', option)
                        }
                        else {
                          props.setFieldValue('martialwithjobstatus', 0)
                        }

                      }}
                      textColor="primary"
                    />
                    {props.touched.martialwithjobstatus &&
                      props.errors.martialwithjobstatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.martialwithjobstatus as string}
                        </Text>
                      )}
                  </View>
                </View>
                {props.values?.filingStatus == 2 &&
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'No one else can claim your spouse as a dependent AND Your spouse is not claiming a withholding allowance for himself / herself*'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title="No one else can claim your spouse as a dependent AND Your spouse is not claiming a withholding allowance for himself / herself"
                        options={options3}
                        selectedOption={mapSelectValue(
                          options3,
                          props.values.spouseclaimingstatus
                        )}
                        onSelect={(option: any) => {
                          if (option == 1) {
                            props.setFieldValue('spouseclaimingstatus', option)
                          }
                          else {
                            props.setFieldValue('spouseclaimingstatus', 0)
                          }


                        }}
                        textColor="primary"
                      />
                      {props.touched.spouseclaimingstatus &&
                        props.errors.spouseclaimingstatus && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.spouseclaimingstatus as string}
                          </Text>
                        )}
                    </View>
                  </View>
                }
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'You may be able to claim additional withholding allowances for age*'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="You may be able to claim additional withholding allowances for age."
                      options={options2}
                      selectedOption={mapSelectValue(
                        options2,
                        props.values.ageadditionalwithholdingallowances
                      )}
                      onSelect={(option: any) => {
                        if (option == 3) {
                          props.setFieldValue('ageadditionalwithholdingallowances', 0)
                        }
                        else {
                          props.setFieldValue('ageadditionalwithholdingallowances', option)
                        }

                      }}
                      textColor="primary"
                    />
                    {props.touched.ageadditionalwithholdingallowances &&
                      props.errors.ageadditionalwithholdingallowances && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.ageadditionalwithholdingallowances as string}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Number of dependents  that you will claim on your tax return *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.noofdependents}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('noofdependents')(text)
                        }
                      }}
                    />

                    {props.touched.noofdependents &&
                      props.errors.noofdependents && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.noofdependents as string}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Are you filing as head of household on your tax return *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Are you filing as head of household on your tax return"
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.claimashousehold
                      )}
                      onSelect={(option: any) => {

                        if (option == 1) {
                          props.setFieldValue('claimashousehold', option)
                        }
                        else {
                          props.setFieldValue('claimashousehold', 0)
                        }
                      }}
                      textColor="primary"
                    />
                    {props.touched.claimashousehold &&
                      props.errors.claimashousehold && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.claimashousehold}
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Do you estimate that you will have at least $250 of total tax credits *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title=" Do you estimate that you will have at least $250 of total tax credits"
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.totaltaxcredits
                      )}
                      onSelect={(option: any) => {
                        if (option == 1) {
                          props.setFieldValue('totaltaxcredits', option)
                        }
                        else {
                          props.setFieldValue('totaltaxcredits', 0)
                        }
                      }}
                      textColor="primary"
                    />
                    {props.touched.totaltaxcredits &&
                      props.errors.totaltaxcredits && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.totaltaxcredits}
                        </Text>
                      )}
                  </View>
                </View>



                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2,

                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary,

                      ]}
                    >
                      {'Total number of allowances you are claiming.'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight, globalStyles.inputReadOnly]}
                      value={totalWithholdingAllowance}
                    // keyboardType="numeric"

                    />
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Do you want to enter Additional amount, if any, you want deducted each pay period*'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Do you want to enter Additional amount, if any, you want deducted each pay period"
                      options={options5}
                      selectedOption={mapSelectValue(
                        options5,
                        props.values.additonalamountstatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('additonalamountstatus', option)
                      }}
                      textColor="primary"
                    />
                    {props.touched.additonalamountstatus &&
                      props.errors.additonalamountstatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additonalamountstatus}
                        </Text>
                      )}
                  </View>
                </View>
                {Number(props.values.additonalamountstatus) == 1 && Number(props.values.additonalamountstatus) != null && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {' Enter additonal amount*'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additonalamount}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additonalamount')(text)
                          }
                        }}
                      />

                      {props.touched.additonalamount &&
                        props.errors.additonalamount && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.additonalamount as string}
                          </Text>
                        )}
                    </View>
                  </View>
                )}
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Are you Planning to itemize or claim adjustments to income*'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Are you Planning to itemize or claim adjustments to income"
                      options={options5}
                      selectedOption={mapSelectValue(
                        options5,
                        props.values.Toclaimadjustincome
                      )}
                      onSelect={(option: any) => {

                        props.setFieldValue('Toclaimadjustincome', option)
                      }}
                      textColor="primary"
                    />
                    {props.touched.Toclaimadjustincome &&
                      props.errors.Toclaimadjustincome && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.Toclaimadjustincome}
                        </Text>
                      )}
                  </View>
                </View>
                {Number(props.values.Toclaimadjustincome) == 1 && Number(props.values.Toclaimadjustincome) != null && (



                  <>
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '50%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Select Tax Filing Status*'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <SelectKeyValue
                          title="Select Tax Filing Status"
                          options={options4}
                          selectedOption={mapSelectValue(
                            options4,
                            props.values.Taxfiling
                          )}
                          onSelect={(option: any) => {
                            const data: any = options4.filter((item) => item.key == option)
                            amount = data[0].amount
                            props.setFieldValue('Taxfiling', option)
                            props.setFieldValue('filingamount', amount)
                          }}
                          textColor="primary"
                        />
                        {props.touched.Taxfiling &&
                          props.errors.Taxfiling && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.Taxfiling}
                            </Text>
                          )}
                      </View>
                    </View>
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '50%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {' Enter an estimate of your current year’s itemized deductions *'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.currentyearitemizeddeductions}
                          keyboardType="numeric"
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('currentyearitemizeddeductions')(text)
                            }
                          }}
                        />

                        {props.touched.currentyearitemizeddeductions &&
                          props.errors.currentyearitemizeddeductions && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.currentyearitemizeddeductions as string}
                            </Text>
                          )}
                      </View>
                    </View>
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '50%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {' Enter an estimate of your current year’s adjustments to income *'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.estimateadjustmentstoincome}
                          keyboardType="numeric"
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('estimateadjustmentstoincome')(text)
                            }
                          }}
                        />
                        {props.touched.estimateadjustmentstoincome &&
                          props.errors.estimateadjustmentstoincome && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.estimateadjustmentstoincome as string}
                            </Text>
                          )}
                      </View>
                    </View>
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '50%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {' Enter an estimate of your current year’s nonwage income (such as dividends or interest income) *'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.estimatenonwageincome}
                          keyboardType="numeric"
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('estimatenonwageincome')(text)
                            }
                          }}
                        />
                        {props.touched.estimatenonwageincome &&
                          props.errors.estimatenonwageincome && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.estimatenonwageincome as string}
                            </Text>
                          )}
                      </View>
                    </View>

                  </>
                )}


                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>

            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default HiinformationForm
